<template>
  <div class="download-app">
    <div class="top"> </div>
    <div class="content">
      <div class="img">
        <img :src="pageData.logo" alt="" />
      </div>
      <div class="title">
        <span>
          {{ pageData.title }}
        </span>
        <span>
          {{ pageData.tag }}
        </span>
      </div>
      <div class="tag">
        <span>版本：{{ pageData.ver }}&nbsp;&nbsp;</span>
        <span>大小：{{ pageData.size }}&nbsp;&nbsp;</span>
        <span>更新时间：{{ pageData.time }}&nbsp;&nbsp;</span>
      </div>
      <div class="button">
        <span v-if="pageData.isInstalling">
          正在安装，请按Home键在桌面查看
        </span>
        <a v-else :href="pageData.url" @click="handleDownloadClickEvent">
          下载安装
        </a>
      </div>
      <div class="link">
        <router-link to="/explainapp">
          “未受信任的企业级开发者”的解决办法
        </router-link>
      </div>
      <div class="tag">
        <span>仅适用于苹果手机</span>
      </div>
    </div>
    <mt-popup v-model="popup.visible" popup-transition="popup-fade" :closeOnClickModal="false">
      <span v-html="popup.text"></span>
    </mt-popup>
  </div>
</template>

<script>
/* global
    PUBLIC_DOWNLOAD_LOGO,
    PUBLIC_DOWNLOAD_TITLE,
    PUBLIC_SYSTEM_FLAG,
    PUBLIC_DOWNLOAD_TYPE,
    PUBLIC_PRODUCT,
    plist_file_url
*/

export default {
  name: 'DownloadApp',
  data() {
    return {
      pageData: {
        logo: require('@/assets/' + PUBLIC_DOWNLOAD_LOGO),
        title: PUBLIC_DOWNLOAD_TITLE,
        url: '',
        tag: '',
        ver: '',
        size: '',
        time: '',
        isInstalling: false,
      },
      popup: {
        visible: false,
        text: '',
      },
    };
  },
  mounted() {
    // 判断是否
    if (PUBLIC_SYSTEM_FLAG === 'android' || !PUBLIC_SYSTEM_FLAG) {
      this.popup.visible = true;
      this.popup.text = '当前页面<br>仅适用于苹果手机';
    } else {
      // 判断是否在微信或QQ中
      const ua = navigator.userAgent.toLowerCase();
      String(ua.match(/micromessenger/i)) === 'micromessenger' && (this.os = 'weixin');
      String(ua.match(/mqqbrowser/i)) === 'mqqbrowser' && ua.match(/tbs/i) === 'tbs' && (this.os = 'qq');
      String(ua.match(/qq/i)) === 'qq' && (this.os = 'qq');
      if (this.os === 'weixin' || this.os === 'qq') {
        this.popup.visible = true;
        this.popup.text = '请点击右上角···按钮<br>然后在弹出的菜单中<br>点击“在Safari中打开”<br>即可下载安装';
      } else {
        this.popup.visible = false;
        this.popup.text = '';
      }
    }

    // 加载数据
    this.initData();
  },
  methods: {
    initData() {
      // 获取下载类型
      const type = PUBLIC_DOWNLOAD_TYPE.toLowerCase().trim();
      let currentType = '';
      switch (type) {
        case 'zd':
          currentType = '终端';
          break;
        case 'zs':
          currentType = '助手';
          break;
        default:
          currentType = '终端';
          break;
      }
      // 获取产品名称
      const n = PUBLIC_PRODUCT.toLowerCase().trim();
      // 获取plist配置文件信息
      const arr = plist_file_url[n].filter(item => item.type === currentType);
      if (arr.length > 0) {
        const i = arr[0];
        this.pageData.url = 'itms-services://?action=download-manifest&url=' + i.url;
        this.pageData.tag = i.tag;
        this.pageData.ver = i.version;
        this.pageData.size = i.size;
        this.pageData.time = i.date;
      } else {
        alert('未获取到下载配置信息');
      }
    },
    handleDownloadClickEvent() {
      setTimeout(() => (this.pageData.isInstalling = true), 1500);
    },
  },
};
</script>
